import baseRequest from "../baseRequest";
import AppConfig from "../../app/config/AppConfig";

class SetLegalWaiverAgreement extends baseRequest {
    constructor(onSuccess) {
        super();
        this.name = 'SetLegalWaiverAgreement';
        this.dispatch = null;
        this.response = null;
        this.config = new AppConfig();
        this.updateState = onSuccess;
    }

    execute(dispatch, payload) {
        this.dispatch = dispatch;
        this.payload = payload;
        this.call(this.config.api.requests.setLegalWaiverAgreement, payload);
    }

    onSuccess() {
        this.updateState(this.response.data);
    }
}

export default SetLegalWaiverAgreement;